import formatDecimal, {
  removeTrailingZeroes,
} from '@paradigm/utils/formatDecimal';
import {
  getEffectiveContractSize,
  getEffectiveQuantityPrecision,
  getProduct,
} from '#/products/domain';
import { Product } from '#/products/types';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';

export function formatQty(value: string, precision = 1): string {
  const numeric = Number.parseFloat(value);
  const rounded = numeric.toFixed(precision);
  const formatted = formatDecimal(rounded);
  return formatted;
}

export function formatProductQty(
  value: string | number,
  productCode?: string | undefined,
  isNormalized = false,
  isDated = false,
): string {
  if (value === NEGATIVE_SIGN) return NEGATIVE_SIGN;
  const strValue = value.toString();
  if (productCode == null) return formatQty(strValue, 1);

  const product = getProduct(productCode);
  const rawValue = isNormalized
    ? strValue
    : normalizeQtyIntoClearingUnits(strValue, product, isDated);
  const numeric = Number.parseFloat(rawValue);
  const rounded = numeric.toFixed(
    getEffectiveQuantityPrecision(product, isDated),
  );
  return formatDecimal(removeTrailingZeroes(rounded));
}

function normalizeQtyIntoClearingUnits(
  value: string,
  product: Product,
  isDated: boolean,
) {
  const result = parseFloat(value) * getEffectiveContractSize(product, isDated);
  return String(result);
}
